import { useTranslation } from 'react-i18next';

import * as St from './OrderInvoice.styles';

import { useOrderInvoice } from '~/UI/pages/OrderSummaryPage/hooks';
import { formatPriceUnitOrFree, formatPriceWithUnit } from '~/core/utils';
import Divider from '~atoms/Divider';
import InvoiceLine from '~atoms/InvoiceLine';
import InvoiceTable from '~atoms/InvoiceTable';

const OrderInvoice = ({
  tableMaxHeight,
  showInstallationFee,
}: {
  tableMaxHeight?: string;
  showInstallationFee?: boolean;
}) => {
  const { t } = useTranslation();
  const { savings, promotionEndDate, subtotal, displayTotal, deliveryCost } =
    useOrderInvoice();
  const installationFee = t('ORDER_SUMMARY.INVOICE.INCLUDED');

  const deliveryFee = t('ORDER_SUMMARY.INVOICE.INCLUDED');
  const promoLabel = promotionEndDate
    ? t('ORDER_SUMMARY.INVOICE.PROMOTION_END', { date: promotionEndDate })
    : undefined;

  return (
    <St.Container>
      <InvoiceTable maxHeight={tableMaxHeight} />

      <Divider m={[0, 0]} />

      <InvoiceLine
        label={`${t('ORDER_SUMMARY.INVOICE.SUBTOTAL')}:`}
        value={formatPriceUnitOrFree(subtotal)}
      />

      {savings ? (
        <InvoiceLine
          color="green"
          label={`${t('ORDER_SUMMARY.INVOICE.SAVINGS_INCLUDED')}:`}
          value={formatPriceUnitOrFree(savings)}
        />
      ) : null}

      <InvoiceLine
        label={`${t('ORDER_SUMMARY.INVOICE.DELIVERY')}:`}
        value={
          !!deliveryCost && deliveryCost > 0
            ? formatPriceWithUnit(deliveryCost)
            : deliveryFee
        }
      />

      {showInstallationFee && (
        <InvoiceLine
          label={`${t('ORDER_SUMMARY.INVOICE.COUNTERTOP_INSTALLATION')}:`}
          value={installationFee}
        />
      )}

      <Divider size="large" mb={0} />

      <InvoiceLine
        size="large"
        label={`${t('ORDER_SUMMARY.INVOICE.TOTAL')}:`}
        value={displayTotal}
      />

      <St.TaxStatement>{t('ORDER_SUMMARY.INVOICE.TAX')}</St.TaxStatement>

      {promoLabel && <InvoiceLine color="red" value={promoLabel} />}
    </St.Container>
  );
};

export default OrderInvoice;
